import { render, staticRenderFns } from "./loginPrice.vue?vue&type=template&id=163b7e34&scoped=true&"
import script from "./loginPrice.vue?vue&type=script&lang=js&"
export * from "./loginPrice.vue?vue&type=script&lang=js&"
import style0 from "./loginPrice.vue?vue&type=style&index=0&id=163b7e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163b7e34",
  null
  
)

export default component.exports